import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { i18n } from "../../translate/i18n";

type Props = {
  title: string,
  text: string,
  text2?: string,
  confirmButtonText: string,
  show: boolean,
  close: () => void,
  submit: () => void,
  cancelButtonColor?: string,
  okButtonColor?: string,
}

const WarningModal: React.FC<Props> = ({ title, text, text2, confirmButtonText, show, close, submit, cancelButtonColor, okButtonColor }) => {
  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={show}
      onClose={close}>
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3}}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <WarningAmberRoundedIcon fontSize="large" color="warning" />
          </Box>
          <Typography sx={{fontSize: 16, fontWeight: 500}}>
            {text}
          </Typography>
          { text2 && <Typography sx={{fontSize: 16, fontWeight: 500}}>{text2}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} color={ cancelButtonColor as any || "primary"}>
          {i18n.t('btnConfirmDialog.cancel') as string}
        </Button>
        <Button variant='contained' onClick={() => { close(); submit(); }} color={okButtonColor as any || "error"}>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WarningModal;
